
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-agatha-accordion]').forEach((accordion) => {
    accordion.querySelectorAll('.agatha-accordion__item').forEach((item, index) => {
      const button = item.querySelector('.agatha-accordion__trigger');
      if (!button) return;
      if (index === 0) item.classList.add('is-open');
      button.addEventListener('click', () => {
        item.classList.toggle('is-open');
      });
    });
  });
});
